import * as React from 'react';

import { Box } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

import { Card, CardContainer } from '../ui/card/card';
import { Centered } from '../ui/centered/centered';

import { OrganizationCard } from './organization-card';

export interface Organization {
	id: string;
	displayName: string;
	entitlementsByOfferingIds?: {
		offeringId: string;
		entitlementIds?: string[];
	}[];
}

interface OrganizationsProps {
	organizations: Organization[];
	isLastItemLoading: boolean;
	selectHandler(arg: string): void;
	isSubmitting: boolean;
	offeringIds?: string[];
}

export const OrganizationsContainer: React.FC<OrganizationsProps> = ({
	organizations = [],
	isLastItemLoading,
	isSubmitting,
	selectHandler,
	offeringIds,
}) => {
	if (organizations?.length === 0) {
		return null;
	}

	const handleSelectHandler = (selectedOrgId: string) => {
		selectHandler(selectedOrgId);
	};

	return (
		<>
			<CardContainer color="dark">
				{organizations?.map((org) => (
					<OrganizationCard
						offeringIds={offeringIds}
						key={org.id}
						id={org.id}
						organization={org}
						selectHandler={handleSelectHandler}
						isSubmitting={isSubmitting}
					/>
				))}
				{!!isLastItemLoading && (
					<React.Fragment>
						<Card
							mainContent={
								<Box>
									<Centered>
										<Spinner size="small" />
									</Centered>
								</Box>
							}
						/>
					</React.Fragment>
				)}
			</CardContainer>
		</>
	);
};
